import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const PopupPromisedTitle = ({ children, isTitle }) => (
  <Text size={isTitle ? 'size2-b' : 'size3-b'} tagType="p" className={cx('popup-promised-title')}>{children}</Text>
);

PopupPromisedTitle.propTypes = {
  children: PropTypes.string,
  isTitle: PropTypes.bool,
};
